import { Pipe, PipeTransform } from '@angular/core';
import { LicensedUserDTO } from '@interfaces/LicenseController';

@Pipe({
  name: 'isUserLicensedInModule'
})
export class IsUserLicensedInModulePipe implements PipeTransform {
  transform(licensedUser: LicensedUserDTO, moduleId: string): boolean {
    return licensedUser.modules.includes(moduleId);
  }
}
